<ion-header>
    <ion-toolbar>
        <ion-buttons *ngIf="!showClose" slot="start">
            <ion-back-button></ion-back-button>
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
    		{{'AddUser' | translate}}
        </ion-title>
        <ion-buttons slot="end">

            <ion-button (click)="dismiss()" *ngIf="showClose" fill="clear">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>


<ion-content class="ion-padding">
    <ion-card>
        <ion-card-content>
            <ion-card-header>
                <ion-row>
                    <ion-col>
                        <h1 style="margin-top: 6px">
                            {{'AddUser' | translate}}
                        </h1>
                    </ion-col>
                    <ion-col>
                        <ion-button class="create" (click)="save()" color="success">
                            <ion-icon slot="start" name="checkmark"></ion-icon>
                            {{'Create' | translate}}
                        </ion-button>
                    </ion-col>
                </ion-row>


            </ion-card-header>

            <form [formGroup]="register">
                <ion-item>
                    <ion-label position="fixed">{{'E-Mail' | translate}}:</ion-label>
                    <ion-input formControlName="email" type="email"></ion-input>
                </ion-item>

                <ion-item>
                    <ion-label position="fixed">{{'FirstName' | translate}}:</ion-label>
                    <ion-input formControlName="firstname" type="text"></ion-input>
                </ion-item>

                <ion-item>
                    <ion-label position="fixed">{{'LastName' | translate}}:</ion-label>
                    <ion-input formControlName="lastname" type="text"></ion-input>
                </ion-item>

                <ion-item>
                    <ion-label position="fixed">{{'USERNAME' | translate}}:</ion-label>
                    <ion-input formControlName="username" type="text"></ion-input>
                </ion-item>

                <ion-item>
                    <ion-label position="fixed">{{'PhoneNumber' | translate}}:</ion-label>
                    <ion-input formControlName="callNumber" type="tel"></ion-input>
                </ion-item>

                <ion-item *ngIf="!isFromPatient">
                    <ion-label position="fixed">{{'UserRole' | translate}}:</ion-label>
                    <ion-select formControlName="role" placeholder="Wählen Sie eine Rolle aus">
                        <ion-select-option *ngFor="let role of rolesArray"
                                           value="{{role}}">{{roles[role]}}</ion-select-option>
                    </ion-select>
                </ion-item>


                <ion-item *ngIf="!isFromPatient">
                    <ion-label position="fixed">{{'AlertGroup' | translate}}:</ion-label>
                    <tag-input [separatorKeys]="[',']" placeholder="" [secondaryPlaceholder]="''" formControlName="alertGroups"></tag-input>
                </ion-item>


                <ion-note  size="small">{{'Message.AfterAdd' | translate}}
                </ion-note>
                <ion-item *ngIf="error" color="danger">
                    <div [innerHtml]="error"></div>
                </ion-item>
            </form>
        </ion-card-content>
    </ion-card>

</ion-content>
